import { createFileRoute } from '@tanstack/react-router';
import { ProposeSemanticModelPage } from '@/features/metric-hub/semantic-models/ProposeSemanticModelPage';

export const Route = createFileRoute('/_authed/metric-hub/semantic-models/new')({
  component: ProposeSemanticModelPage,
});
